import { render, staticRenderFns } from "./ProjectsSettings.vue?vue&type=template&id=0b83b740&scoped=true"
import script from "./ProjectsSettings.vue?vue&type=script&lang=js"
export * from "./ProjectsSettings.vue?vue&type=script&lang=js"
import style0 from "./ProjectsSettings.vue?vue&type=style&index=0&id=0b83b740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83b740",
  null
  
)

export default component.exports